export type MenuItem = {
  key: string;
  label: string;
  path: string;
  requiredFeatureFlags?: string[];
  requiredRoles?: string[];
  icon?: string;
};

export const APP_MENU = {
  'menu.welcome': [{ key: 'college-home', label: 'menu.home', path: '/', icon: 'home' }],
  'menu.content': [
    {
      key: 'college-lessons',
      label: 'menu.lessons',
      path: '/lessons',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'college-lives',
      label: 'menu.lives',
      path: '/lives/',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'college-articles',
      label: 'menu.articles',
      path: '/articles',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'college-exercises',
      label: 'menu.exercises',
      path: '/exercises',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'college-videos',
      label: 'menu.videos',
      path: '/videos',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'college-review-lists',
      label: 'menu.reviewLists',
      path: '/review-lists',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
  ],
  'menu.pedagogicalHierarchy': [
    {
      key: 'college-windows',
      label: 'menu.windows',
      path: '/windows',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'college-courses',
      label: 'menu.courses',
      path: '/courses',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'college-curriculum-paths',
      label: 'menu.curriculumPaths',
      path: '/curriculum-paths',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'college-module-blocks',
      label: 'menu.moduleBlocks',
      path: '/module-blocks',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'college-modules',
      label: 'menu.modules',
      path: '/modules',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'college-sub-modules',
      label: 'menu.subModules',
      path: '/submodules',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'college-disciplines',
      label: 'menu.disciplines',
      path: '/disciplines',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'college-discipline-instances',
      label: 'menu.disciplineInstances',
      path: '/discipline-instances',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'college-jacad-desco-mappings',
      label: 'menu.jacadDescoMappings',
      path: '/jacad-desco-mappings',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'college-jacad-discipline-registrations',
      label: 'menu.jacadDisciplineRegistrations',
      path: '/jacad-discipline-registrations',
      requiredRoles: ['admin'],
      requiredFeatureFlags: [],
    },
  ],
  'menu.assessmentsManagement': [
    {
      key: 'assessments-activities-dates-and-grades',
      label: 'menu.datesActivitiesAndGrades',
      path: '/assessments-management/analyse-undergrad-activities/',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'assessments-deadline-extension',
      label: 'menu.deadlineExtension',
      path: '/assessments-management/deadline-extension/',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'assessments-grades-consolidation-processes',
      label: 'menu.gradesConsolidation',
      path: '/assessments-management/grades-consolidation/',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'microcertificates-manual-eligibility',
      label: 'menu.microcertificatesManualEligibility',
      path: '/assessments-management/microcertificates-manual-eligibility/',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'evaluation-overrides',
      label: 'menu.evaluationOverrides',
      path: '/assessments-management/exercise-override/',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
  ],
  'menu.correction': [
    {
      key: 'assessments-evaluate-think-and-answer',
      label: 'menu.thinkAndAnswer',
      path: '/assessments/exercises-grading/think-and-answer/',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'assessments-evaluate-practices',
      label: 'menu.practiceExercises',
      path: '/assessments/exercises-grading/practice/',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'assessments-evaluate-extension-projects',
      label: 'menu.extensionProjects',
      path: '/assessments/exercises-grading/extension-projects/',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'setup-ai-activities',
      label: 'menu.setupAIActivities',
      path: '/setup-ai-activities',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
  ],
  'menu.studentSection': [
    {
      key: 'manage-student',
      label: 'menu.studentManagement',
      path: '/manage-students',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
  ],
  'menu.courseEnrollments': [
    {
      key: 'manage-enrollment',
      label: 'menu.manageEnrollment',
      path: '/manage-enrollment',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'bulk-course-enrollment',
      label: 'menu.bulkEnrollInCourse',
      path: '/enroll-students-in-course',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
  ],
  'menu.prouni': [
    {
      key: 'prouni-applications',
      label: 'menu.prouniApplications',
      path: '/prouni',
      requiredRoles: ['admin'],
      requiredFeatureFlags: [],
    },
  ],
  'menu.disciplineRegistrations': [
    {
      key: 'discipline-registration-reports',
      label: 'menu.disciplineRegistrationReports',
      path: '/discipline-registration-reports',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'enroll-in-classrooms',
      label: 'menu.bulkEnrollInDisciplines',
      path: '/discipline-bulk-enrollment',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
    {
      key: 'unenroll-in-classrooms',
      label: 'menu.bulkUnenrollInDisciplines',
      path: '/unenroll-discipline-in-bulk',
      requiredRoles: [],
      requiredFeatureFlags: [],
    },
  ],
};
